import Checklist from './checklist';
import './checklist.scss';

export default Checklist;
